import { keyframes, styled } from "goober";
import { Blob } from "./Blob";
import { ShimmerSpan } from "./ShimmerSpan";
import { Text } from "./Text";
import { TypewriterSpan } from "./TypewriterSpan";

const blobPulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
`;

const BlobContainer = styled("div")`
  display: flex;
  align-items: stretch;
  justify-content: center;
  height: 12px;
  width: 12px;

  &[data-pending="true"] {
    animation: ${blobPulse} 1s ease-in-out infinite;
  }
`;

const Name = styled("span")`
  font-weight: 450;
  color: var(--text-primary);
  margin-right: 6px;
`;

type Props = {
  color: string;
  name?: string | null;
  done: boolean;
  interrupted?: boolean;
  pastParticiple: string;
  inProgress: string;
};
export function Step({
  color,
  name,
  done,
  interrupted,
  pastParticiple,
  inProgress,
}: Props) {
  const statusText = done ? pastParticiple : inProgress;
  const pending = !done && !interrupted;

  return (
    <>
      <BlobContainer data-pending={pending}>
        <Blob colors={[color]} width={4} />
      </BlobContainer>
      <Text variant="text-small" color="var(--text-secondary)" ellipsis>
        {name && <Name>{name}</Name>}
        {statusText && (
          <ShimmerSpan data-pending={pending}>
            <TypewriterSpan>{statusText}</TypewriterSpan>
          </ShimmerSpan>
        )}
      </Text>
    </>
  );
}
